
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Message from '@/components/message.vue';
import {
	activityMarkdowndata
} from "@/api/material"

@Component({
	name: '',
	components: {
		PageFooter,
		'slz-message': Message,
	}
})

export default class FullsubtractionDatas extends Vue {
	private activityId = this.$route.query.id;
	private activityName = this.$route.query.name;
	private keywords = ''
	private pageSize = 20
	private pageNo = 1
	private total = 0
	private tablelist: any = []
	private tableloading = false


	private mounted() {
		this.gettablelist()
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
	private clearSearch() {
		this.keywords = ''
		this.doSearch()
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	async gettablelist() {
		try {
			this.tableloading = true
			let data: any = {
				Id: this.activityId,
				Keywords: this.keywords,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			}
			let res: any = await activityMarkdowndata(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
	private handleExport(){
		let url = `${location.origin}/pc/activityMarkdown/dataExport?Id=${this.activityId}&Keywords=${this.keywords}`;
		window.open(url);
	}
	private handleBack(){
		this.$router.replace({
			name: 'fullsubtraction'
		});
	}
}
